import { SVGProps } from 'react';

export const XmarkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M13.332 4.075L9.426 7.98l3.9 3.932a.964.964 0 010 1.406.964.964 0 01-1.406 0l-3.9-3.9-3.945 3.914a.964.964 0 01-1.407 0 .964.964 0 010-1.406L6.582 7.98 2.676 4.074a.964.964 0 010-1.406.964.964 0 011.406 0L8.02 6.574l3.905-3.905a.964.964 0 011.407 0 .964.964 0 010 1.406z"
      fill="currentColor"
    />
  </svg>
);
